export enum TimedPlusStatus {
    Extended = 'extended',
    NotStarted = 'notStarted',
    PendingRegistration = 'pendingRegistration',
    Started = 'started',
    Withdrawn = 'withdrawn',
}
